/**
 * Flush contract for work a renderer owes before an audio note is written.
 *
 * The meeting notepad holds typed text in the overlay renderer behind a debounce
 * and pushes it to the server document. A save can start anywhere — the stop
 * button, quitting, a meeting ending, the inactivity stop — and every one of
 * those runs in main, so main asks the overlay to settle first rather than each
 * call site remembering to.
 */

/** GlobalEvents.invoke: main → overlay renderer, resolves once the flush settles. */
export const BEFORE_AUDIO_NOTE_SAVE_EVENT = 'audio-note:before-save'

/**
 * Cap on how long a save waits for that flush. The notes are already on disk;
 * a wedged or slow renderer costs server freshness, never the meeting.
 */
export const BEFORE_AUDIO_NOTE_SAVE_TIMEOUT_MS = 3_000
